import { useState, useEffect } from 'react';
import { Select, MenuItem } from '@mui/material';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import 'antd/dist/antd.css';

const CustomFilterInput = (props: any) => {
  const { item, applyValue, enumValues, dataType } = props;

  const [dateValue, setDateValue] = useState<[Moment | null, Moment | null] | null>(null);
  const [textValue, setTextValue] = useState('');

  useEffect(() => {
    if (dataType === 'date') {
      if (item.value && Array.isArray(item.value) && item.value.length === 2) {
        setDateValue([moment(item.value[0]), moment(item.value[1])]);
      } else {
        setDateValue(null);
      }
    }

    if (!enumValues && dataType !== 'date') {
      setTextValue(item.value || '');
    }
  }, [item.value, dataType, enumValues]);

  const commonStyle = {
    width: '100%',
    height: '40px',
  };

  if (dataType === 'date') {
    return (
      <DatePicker.RangePicker
        style={commonStyle}
        value={dateValue}
        onChange={(dates) => {
          setDateValue(dates);
          if (dates && dates.length === 2 && dates[0] && dates[1]) {
            applyValue({ ...item, value: [dates[0].format('YYYY-MM-DD'), dates[1].format('YYYY-MM-DD')] });
          } else {
            applyValue({ ...item, value: null });
          }
        }}
        placeholder={['Başlangıç tarihi', 'Bitiş tarihi']}
        format="DD.MM.YYYY"
      />
    );
  }

  if (enumValues) {
    return (
      <Select
        value={item.value || ''}
        onChange={(e) => {
          applyValue({ ...item, value: e.target.value });
        }}
        style={commonStyle}
        displayEmpty
      >
        <MenuItem value="">
          <em>Tümü</em>
        </MenuItem>
        {Object.entries(enumValues).map(([key, val]) => (
          <MenuItem key={key} value={String(val)}>
            {key}
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <input
      value={textValue}
      onChange={(e) => setTextValue(e.target.value)} 
      placeholder="Filtrele..."
      style={commonStyle}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          applyValue({ ...item, value: textValue });
        }
      }}
    />
  );
};

export default CustomFilterInput;
